<template lang="pug">
.info-miner.w100.pos-r.padding-referral.has-text-left
  .columns
    .column.is-half
      template(v-if="customReferralCode")
        div 
          span Your  
          b Custom  
          span  Referral code:
        #referral_code.referral-code.hint--right(
          aria-label='Copy'
          @click="copyToClipboard(customReferralCode)"
          :class="{'fs-29': customReferralCode.length > 10 }"
        ) {{ customReferralCode }}
        div
        #referral_link.referral-link.hint--right(
          aria-label='Copy'
          @click="copyToClipboard(customReferralLink)"
        ) {{ customReferralLink }}
        br
      template(v-else)
        div Your Referral code:
        #referral_code.referral-code.hint--right(
          aria-label='Copy'
          @click="copyToClipboard(referralCode)"
        ) {{ referralCode }}
        div
        #referral_link.referral-link.hint--right(
          aria-label='Copy'
          @click="copyToClipboard(referralLink)"
        ) {{ referralLink }}
      .mb-10
        span Share your referral code to  
        b
          a.s12(href='/referrals') earn {{ customCodeTierPercentage || "0.25" }}% of your referral's mining rewards  
        span  , passively!
      template(v-if="count === 0")
        span No workers are currently using your referral code!
      template(v-else)
        span There are currently 
        strong.text-white-on-dark {{ count }} 
        span active worker
        span(v-if="count !== 1") s
        span  using your referral code.
      template(v-if="customReferralCode")
        //- .mt-10.mb-10 You can keep sharing your previous referral code, it will work just fine!
        //- #referral_link.referral-link.hint--right(
        //-   aria-label='Copy'
        //-   @click="copyToClipboard(referralLink)"
        //- ) {{ referralLink }}
        .mt-10.mb-10 
          span Note that using your own Custom Referral Code on your own workers won't work.
        hr
        div
          span You are currently on 
          span.tag.tag-referral.ml-0 {{ customCodeTierName }} 
          span &nbsp;
          span earning 
          b {{ customCodeTierPercentage }}%  
          span from your referral rewards.

        //- div.mt-10.referral-image-container
        //-   ReferralImage.referral-image-cc(
        //-     :showDetail="true", 
        //-     :tier="currentTier",
        //-     type="contentCreator"
        //- )

        ReferralCustomChart(:uuid='uuid')
    .column.is-half(v-if="list.length > 0")

      template(v-if="list.length > 0")
        table.table.is-fullwidth.table
          thead
            tr
              th 
                span Referred worker
              th.has-text-right
                span Last seen
          tbody

            tr(
              v-for="item in list"
            ) 
              td 
                span.w100.s12.w400 {{ item.name }} 
              td.has-text-right
                span.w100.s12 {{ item.last_seen | fromNow }} 

        .bottom-controls-payments
          .page-switch.first.hint--bottom-right(
            v-if="hasPrev"
            aria-label="First page"
            @click="first"
          )
            button.button.is-small
              i.fa.fa-angle-double-left
          .page-switch.prev.hint--bottom-right(
            v-if="hasPrev"
            aria-label="Previous page"
            @click="prev"
          )
            button.button.is-small
              i.fa.fa-angle-left
          .page-switch.next.hint--bottom-left(
            v-if="hasNext"
            aria-label="Next page"
            @click="next"
          )
            button.button.is-small
              i.fa.fa-angle-right
          .page-switch.last.hint--bottom-left(
            v-if="hasNext"
            aria-label="Last page"
            @click="last"
          )
            button.button.is-small
              i.fa.fa-angle-double-right

</template>

<script>
import { apiGet } from '../util/general'
import ReferralCustomChart from '../components/c_referral_custom_chart'
import ReferralImage from '../components/c_referral_image'
export default {
  name: 'c_tab_referral',
  props: ['uuid'],
  data() {
    return {
      referralCode: '',
      referralLink: '',
      isLoading: false,
      list: [],
      page: 1,
      disclaimer: '',
      hasNext: false,
      hasPrev: false,
      lastPage: 0,
      count: 0,
      totalReferredWorkers: 0,
      customReferralCode: null,
      customReferralLink: null,
      tierOption: null,
      customCodeTier: null,
      customCodeTierName: null,
      customCodeTierPercentage: null
    }
  },
  computed: {
    tiers() {
      return this.$store.getters.tiers
    },
    currentTier() {
      let vm = this
      let tier = vm.tiers.find(element => element.code === vm.customCodeTier)
      return tier
    }
  },
  components: {
    ReferralCustomChart,
    ReferralImage
  },
  // async created() {
  //   let vm = this
  //   if (!(vm.$store.getters.tiers && vm.$store.getters.tiers.length > 0)) {
  //     await vm.$store.dispatch('getTiers')
  //   }
  // },
  async mounted() {
    let vm = this
    if (!(vm.$store.getters.tiers && vm.$store.getters.tiers.length > 0)) {
      await vm.$store.dispatch('getTiers')
    }
    vm.fetch()
    vm.$socket.client.emit('join_account', vm.uuid);
  },
  methods: {
    first() {
      let vm = this
      vm.page = 1
      vm.fetch()
    },
    next() {
      let vm = this
      vm.page = vm.page + 1
      vm.fetch()
    },
    prev() {
      let vm = this
      vm.page = vm.page - 1
      vm.fetch()
    },
    last() {
      let vm = this
      vm.page = vm.lastPage
      vm.fetch()
    },
    fetch() {
      let vm = this
      vm.isLoading = true
      vm.$emit('startLoading')

      let url = '/v5/account/' + vm.uuid + '/referrals'
      if (vm.page > 1) url += '?page=' + (vm.page || 1)

      let obj = {}
      apiGet(vm, url, obj, function (data) {
        if (!data.success) {
          vm.$store.dispatch('notifyError', data.msg)
        } else {
          vm.referralCode = data.data.code
          vm.referralLink = window.location.origin + '/?ref=' + data.data.code

          vm.hasNext = data.data.has_next || false
          vm.hasPrev = data.data.has_prev || false
          vm.list = data.data.list || []
          vm.lastPage = data.data.last_page || false
          vm.count = data.data.count || 0
          vm.customReferralCode = data.data.custom_code
          if (vm.customReferralCode) {
            vm.customReferralLink = window.location.origin + '/?ref=' + vm.customReferralCode
            vm.customCodeTier = data.data.custom_code_tier
            if (!vm.customCodeTier) {
              let baseTier = vm.tiers.find(element => element.code === 0)
              vm.customCodeTier = baseTier.code
              vm.customCodeTierName = baseTier.name
              vm.customCodeTierPercentage = baseTier.owner_percentage
            } else {
              let currentTier = vm.tiers.find(element => +element.code === +vm.customCodeTier)
              vm.customCodeTierName = currentTier.name
              vm.customCodeTierPercentage = currentTier.owner_percentage
            }
          }
        }
      }, function (err) {
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoading = false
        vm.$emit('stopLoading')
      })
    },
    copyToClipboard(text) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', 'Text copied!')
    }
  }
}
</script>

<style lang="stylus" scoped>
.padding-referral
  padding 10px 10px 25px 10px
  
.referral-code
  font-size: 40px;
  font-weight: 500;
  cursor: pointer;
  padding: 10px 0;
  overflow-wrap: anywhere;

.referral-link
  font-size: 11px;
  margin-bottom: 10px;
  cursor: pointer;
  font-weight: 400;
  color: gray;

.table
  td, th
    padding .4em .2em
  tr td
    vertical-align: middle
  
.table.loading
  pointer-events: none;
  position relative
  &:before
    height 100%
    width 100%
    position: absolute
    opacity .7
    background-color: #fff
    content: ""
    top 0px
    left 0px
  &:after
    content: "Loading...";
    position: absolute;
    top: 50px;
    left: 0px;
    font-weight: 400;
    font-size: 15px
    width: 100%;
    text-align: center;

.top-controls-payments, .bottom-controls-payments
  position relative
  margin-bottom: 30px;

.page-switch
  display: inline-block;
  position: absolute;
  top: -4px;
  &.first
    left: 0px;
  &.prev
    left: 30px;
  &.next
    right: 30px;
  &.last
    right: 0px;

.tag-referral
  margin-left 5px
  background-color: #72CBB2;
  color: white;
  font-weight: bold;
  &.ml-0
    margin-left 0


.fs-29
  font-size 29px
</style>



// WEBPACK FOOTER //
// c_tab_referral.vue?69b2864e